const SPECIAL_CHARACTER_SIGN = '#';

const getAlphabetArray = () => {
  return Array.from({ length: 26 }, (_, index) => String.fromCharCode('A'.charCodeAt(0) + index));
};

/*
SAMPLE RESPONSE : {A: [], B:[], C:[], ... Z:[], #:[]}
*/
export const getAlphaBetList = () => {
  const alphaBetArray = getAlphabetArray();
  alphaBetArray.push(SPECIAL_CHARACTER_SIGN);
  const alphaBetList = alphaBetArray.reduce((key, value) => {
    Object.assign(key, { [value]: [] });
    return key;
  }, {});
  return alphaBetList || {};
};

export const startsWithSpecialChatacter = (str) => {
  return str[0].toUpperCase() === str[0].toLowerCase();
};
/*
SAMPLE RESPONSE : {A: [{id: '', label: '', children: []}, B: [{id: '', label: ', children: []}] ....}
*/
export const getAlphaBetIndexedCategories = (designerCategories = []) => {
  const sortedList = getAlphaBetList();
  designerCategories.forEach((category) => {
    const label = category.label || category.value;
    const key = category.key || encodeURI(category.label);

    if (label) {
      const key = !startsWithSpecialChatacter(label) ? label[0].toUpperCase() : SPECIAL_CHARACTER_SIGN;
      if (!sortedList[key]) sortedList[key] = [];
      return sortedList[key].push(category);
    }

    const indexLetter = !startsWithSpecialChatacter(key) ? key[0].toUpperCase() : SPECIAL_CHARACTER_SIGN;
    if (!sortedList[indexLetter]) sortedList[indexLetter] = [];
    return sortedList[indexLetter].push({ ...category, label: key });
  });

  return sortedList || {};
};

/**
 * @param {Object} data contains @property children (array of items) and @property alphabet (map holding the position of the first encounter in a list).
 * @returns {Array} list of items with added alphaKey property to each relevant item.
 */

export const getItemsListWithAlphaKey = (children, alphabet) => {
  const list = [...children];

  Object.keys(alphabet).forEach((letter) => {
    const idx = alphabet[letter];
    const alphaKey = letter;

    if (list[idx]) {
      Object.assign(list[idx], { alphaKey });
    }
  });
  return list;
};

/**
 * @param {Object} data contains @property alphabet (map holding the position of the first encounter in a list).
 * @returns {Object} map including full alphabet position of the first encounter in a list (-1 if there is no item starting with the letter).
 */

export const getAlphabetNavigationMap = (alphabet) => {
  const result = {};
  const list = getAlphabetArray();

  list.push(SPECIAL_CHARACTER_SIGN);
  list.forEach((letter) => {
    result[letter] = -1;
  });

  Object.entries(alphabet)
    .sort(([, aIndex], [, bIndex]) => aIndex - bIndex)
    .forEach(([letter]) => {
      let index = letter;

      if (startsWithSpecialChatacter(letter)) {
        if (result[SPECIAL_CHARACTER_SIGN] !== -1) {
          return;
        }

        index = SPECIAL_CHARACTER_SIGN;
      }

      result[index] = alphabet[letter];
    });

  return result;
};
